<template>
  <v-carousel
    class="carousel"
    interval="1185"
    height="290"
    :hide-delimiters="items.length === 1"
    :show-arrows="items.length > 1"
    :cycle="items.length > 1"
    hide-delimiter-background
    show-arrows-on-hover
    cycle
    light
  >
    <v-carousel-item
      v-for="item in items"
      :key="item.id"
      :src="item.banner_url"
      :class="{clickable: item.link && !item.show_link_button}"
      @click="item.link && !item.show_link_button ? goToLink(item.link, item.target) : null"
      reverse-transition="fade-transition"
      transition="fade-transition"
      class="carousel__item"
    >
      <div v-if="item.link && item.show_link_button" class="carousel__content">
        <v-btn
          class="carousel__content-btn"
          v-if="IsRemoteUrl(item.link)"
          :href="item.link"
          :target="item.target"
        >Подробнее</v-btn>
        <v-btn
          class="carousel__content-btn"
          v-else
          :to="item.link"
        >Подробнее</v-btn>
      </div>
    </v-carousel-item>
  </v-carousel>
</template>

<script>
  export default {
    props: ['items'],
    methods: {
      IsRemoteUrl(url) {
        return (url.indexOf('://') !== -1);
      },
      goToLink(link, target) {
        window.open(link, target);
      },
    },
  };
</script>

<style lang="scss">
  @import '../../assets/scss/variables';

  .carousel {
    background: $carousel-bg-color;

    .v-image__image--cover {
      background-size: contain;

      @media all and (min-width: 1260px){
        background-size: cover;
      }
    }

    .v-icon.v-icon {
      color: white!important;
    }

    &__content {
      display: flex;
      height: 100%;
      justify-content: center;
      align-items: flex-end;
      padding-bottom: 60px;
    }
  }
  .clickable {
    cursor: pointer;
  }
</style>
